@if (demand.noticeSession.forcedClosure) {
	<!-- spec 024: encerramento forçado é terminal — Abrir/Fechar/Encerrar somem, só o
		indicativo com a justificativa fica visível. -->
	<small class="badge badge-sm rounded-2 fw-600 text-bg-danger" [ngbTooltip]="demand.noticeSession.forcedClosureJustification">
		<fa-icon icon="ban" class="me-1"></fa-icon>
		Sessão encerrada
	</small>
} @else if (!demand.loose && (demand.publishStatusDone || accountService.account.isProductDispensaLink)) {
	@if (demand.noticeSession.statusCreated) {
		@if (openBlockedByNotice) {
			<small
				class="ms-2 badge badge-sm rounded-2 fw-600 text-bg-light"
				ngbTooltip="No Pregão e na Concorrência, a inscrição e a sessão exigem o edital publicado">
				<fa-icon icon="circle-info" class="me-1"></fa-icon>
				Publique o edital para abrir a sessão
			</small>
		} @else {
			<button
				class="ms-2 btn btn-sm btn-indigo fw-700 rounded-2"
				(click)="sessionOpened()"
				[disabled]="submitted"
				*permissions="'dispute.session.manage'">
				<app-label-loading-dots [loading]="submitted" label="Abrir Sessão"></app-label-loading-dots>
			</button>
		}
	} @else if (demand.noticeSession.statusOpened) {
		<button class="ms-2 btn btn-sm btn-danger fw-700 rounded-2" (click)="sessionClosed()" [disabled]="submitted">
			<app-label-loading-dots [loading]="submitted" label="Fechar Sessão"></app-label-loading-dots>
		</button>
	} @else if (demand.noticeSession.statusClosed) {
		<button class="ms-2 btn btn-sm btn-indigo fw-700 rounded-2" (click)="sessionOpened()" [disabled]="submitted" *permissions="'dispute.session.manage'">
			<app-label-loading-dots [loading]="submitted" label="Reabrir Sessão"></app-label-loading-dots>
		</button>
	}
}
